module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-1451a23c!./packages/dof-music-player/colmo.css
// module id = 432
// module chunks = 0 1